"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SzCheckbox = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_bootstrap_1 = require("react-bootstrap");
require("./SzCheckbox.scss");
function SzCheckbox(_a) {
    var checked = _a.checked, className = _a.className, disabled = _a.disabled, label = _a.label, name = _a.name, onChange = _a.onChange, type = _a.type, value = _a.value, id = _a.id;
    var formCheckClasses = classnames_1.default('sz-checkbox', className, {
        checked: checked
    });
    return (react_1.default.createElement(react_bootstrap_1.Form.Check, { custom: true, className: formCheckClasses, disabled: disabled, name: name, type: type, label: label, checked: checked, onChange: onChange, value: value, id: id }));
}
exports.SzCheckbox = SzCheckbox;
exports.default = SzCheckbox;
